import React from "react";
import { Avatar } from "@mui/material";
import { Link } from "react-router-dom";
import "./profile-slider.css";

function ProfileCard({ onClose, selectedUser, userDepartment, userRole, isOpen }) {
    return (
        <div className={`profile-preview ${isOpen ? "fadeIn" : "fadeOut"}`}>
            <div className="profile-data">
                <div className="profile-img">
                    <Avatar 
                        src={selectedUser?.ProfileImageUrl} 
                        alt={selectedUser?.FirstName} 
                        sx={{ width: 90, height: 90 }} 
                    />
                </div>

                {(userRole === "administrator" || userDepartment === "HR") && selectedUser?._id && ( 
                    <div className="profileLink">
                        <Link to={`/employee-profile/${selectedUser?._id}`}>View Full Profile</Link>
                    </div>
                )}

                <div className="profile-body">
                    <span className="user-name">{`${selectedUser?.FirstName} ${selectedUser?.LastName}`}</span>
                    <div className="user-info">
                        <span className="user-label">Designation:</span> 
                        <span>{selectedUser?.Designation || "NA"}</span>
                    </div>
                    <div className="user-info">
                        <span className="user-label">Phone:</span> 
                        <span>{selectedUser?.OfficalPhone || "NA"}</span>
                    </div>
                    <div className="user-info">
                        <span className="user-label">Email:</span> 
                        <span>{selectedUser?.OfficeEmail || "NA"}</span>
                    </div>
                    <div className="user-info">
                        <span className="user-label">Service Area:</span> 
                        <span>{selectedUser?.Location || "NA"}</span>
                    </div>
                </div>

                <button className="close-button" onClick={onClose}>Close</button>
            </div>
        </div>
    );
}

export default ProfileCard;
